import * as React from 'react';
export const bmoharrisSvg = React.forwardRef(function bmoharrisSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ED3124',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.395 26h19.2v-6.097h-19.2V26Zm5.454-19.686a.788.788 0 0 0-1.245-.02l-4.209 5.3v8.309l4.177-5.364a.808.808 0 0 1 .639-.315c.261 0 .492.126.649.315l3.549 4.64a.733.733 0 0 0 1.172 0l3.55-4.64a.83.83 0 0 1 .648-.315c.262 0 .492.126.639.315l4.177 5.364v-8.308l-4.208-5.302A.796.796 0 0 0 20.769 6a.803.803 0 0 0-.628.314l-3.539 4.61a.774.774 0 0 1-.617.304.759.759 0 0 1-.618-.304l-3.518-4.61Z',
      fill: '#FEFEFE',
    }),
  );
});
bmoharrisSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bmoharris = {
  category: 'brand',
  colorable: false,
  name: 'bmoharris',
  svg: bmoharrisSvg,
};
